export const DEFAULT_MANTRA_ROLE_CONFIGURATION = [
  { name: 'Carnesecchi', roles: ['Por'] },
  { name: 'Milinkovic-Savic V', roles: ['Por'] },
  { name: 'Maignan', roles: ['Por'] },
  { name: 'Svilar', roles: ['Por'] },
  { name: 'Butez', roles: ['Por'] },
  { name: 'Di Gregorio', roles: ['Por'] },
  { name: 'Falcone', roles: ['Por'] },
  { name: 'Skorupski', roles: ['Por'] },
  { name: 'Provedel', roles: ['Por'] },
  { name: 'Okoye', roles: ['Por'] },
  { name: 'Audero', roles: ['Por'] },
  { name: 'De Gea', roles: ['Por'] },
  { name: 'Sommer', roles: ['Por'] },
  { name: 'Caprile', roles: ['Por'] },
  { name: 'Montipo\'', roles: ['Por'] },
  { name: 'Bijlow', roles: ['Por'] },
  { name: 'Borghi', roles: ['Por'] },
  { name: 'Corvi', roles: ['Por'] },
  { name: 'Muric A', roles: ['Por'] },
  { name: 'Paleari', roles: ['Por'] },
  { name: 'Perin', roles: ['Por'] },
  { name: 'Meret', roles: ['Por'] },
  { name: 'Semper', roles: ['Por'] },
  { name: 'Leali', roles: ['Por'] },
  { name: 'Suzuki', roles: ['Por'] },
  { name: 'Motta E', roles: ['Por'] },
  { name: 'Ravaglia F', roles: ['Por'] },
  { name: 'Pessina M', roles: ['Por'] },
  { name: 'Martinez J', roles: ['Por'] },
  { name: 'Nicolas', roles: ['Por'] },
  { name: 'Turati', roles: ['Por'] },
  { name: 'Rossi F', roles: ['Por'] },
  { name: 'Sportiello', roles: ['Por'] },
  { name: 'Ciocci', roles: ['Por'] },
  { name: 'Vigorito', roles: ['Por'] },
  { name: 'Nava', roles: ['Por'] },
  { name: 'Christensen', roles: ['Por'] },
  { name: 'Siegrist', roles: ['Por'] },
  { name: 'Sommariva', roles: ['Por'] },
  { name: 'Di Gennaro R', roles: ['Por'] },
  { name: 'Pinsoglio', roles: ['Por'] },
  { name: 'Furlanetto', roles: ['Por'] },
  { name: 'Fruchtl', roles: ['Por'] },
  { name: 'Samooja', roles: ['Por'] },
  { name: 'Terracciano', roles: ['Por'] },
  { name: 'Torriani', roles: ['Por'] },
  { name: 'Contini', roles: ['Por'] },
  { name: 'Rinaldi', roles: ['Por'] },
  { name: 'Scuffet', roles: ['Por'] },
  { name: 'Zelezny', roles: ['Por'] },
  { name: 'Gollini', roles: ['Por'] },
  { name: 'Satalino', roles: ['Por'] },
  { name: 'Israel', roles: ['Por'] },
  { name: 'Padelli', roles: ['Por'] },
  { name: 'Sava', roles: ['Por'] },
  { name: 'Perilli', roles: ['Por'] },
  { name: 'Nunziante', roles: ['Por'] },
  { name: 'Lezzerini', roles: ['Por'] },
  { name: 'Silvestri', roles: ['Por'] },
  { name: 'Toniolo', roles: ['Por'] },
  { name: 'Cavlina', roles: ['Por'] },
  { name: 'Ferrante', roles: ['Por'] },
  { name: 'Calligaris', roles: ['Por'] },
  { name: 'Tornqvist', roles: ['Por'] },
  { name: 'Sherri', roles: ['Por'] },
  { name: 'Siviero', roles: ['Por'] },
  { name: 'Pannozzo', roles: ['Por'] },
  { name: 'Giacomone', roles: ['Por'] },
  { name: 'Dimarco', roles: ['E', 'W'] },
  { name: 'Bremer', roles: ['Dc'] },
  { name: 'Spinazzola', roles: ['Ds', 'E'] },
  { name: 'Pavlovic S', roles: ['Dc'] },
  { name: 'Scalvini', roles: ['Dc'] },
  { name: 'Palestra', roles: ['E'] },
  { name: 'Kempf', roles: ['Dc'] },
  { name: 'Bisseck', roles: ['Dc'] },
  { name: 'Ostigard', roles: ['Dc'] },
  { name: 'Bastoni', roles: ['Dc'] },
  { name: 'Kalulu', roles: ['Dd', 'Dc'] },
  { name: 'Celik', roles: ['B', 'Dd', 'E'] },
  { name: 'Solet', roles: ['Dc'] },
  { name: 'Akanji', roles: ['Dc'] },
  { name: 'NDicka', roles: ['Dc'] },
  { name: 'Wesley F', roles: ['E'] },
  { name: 'Zappacosta', roles: ['Dd', 'E'] },
  { name: 'Dumfries', roles: ['E'] },
  { name: 'Bartesaghi', roles: ['Ds', 'E'] },
  { name: 'Mancini', roles: ['Dc'] },
  { name: 'Kabasele', roles: ['Dc'] },
  { name: 'Vojvoda', roles: ['Dd', 'E'] },
  { name: 'Martin', roles: ['Ds', 'E'] },
  { name: 'Kelly', roles: ['Ds', 'Dc'] },
  { name: 'Baschirotto', roles: ['Dc'] },
  { name: 'Delprato', roles: ['B', 'Dd', 'E'] },
  { name: 'Valeri', roles: ['Ds', 'E'] },
  { name: 'Ramon J', roles: ['Dc'] },
  { name: 'Bernasconi', roles: ['Ds', 'E'] },
  { name: 'Holm', roles: ['Dd', 'E'] },
  { name: 'Alex Valle', roles: ['Ds', 'E'] },
  { name: 'Gosens', roles: ['E'] },
  { name: 'Vasquez', roles: ['Ds', 'Dc'] },
  { name: 'Carlos Augusto', roles: ['B', 'Ds', 'E'] },
  { name: 'Cambiaso', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Tiago Gabriel', roles: ['Dc'] },
  { name: 'Beukema', roles: ['Dc'] },
  { name: 'Hermoso', roles: ['Dc'] },
  { name: 'Coco S', roles: ['Dc'] },
  { name: 'Gutierrez M', roles: ['Ds', 'E'] },
  { name: 'Miranda J', roles: ['Ds', 'E'] },
  { name: 'Luperto', roles: ['Dc'] },
  { name: 'Moreno A', roles: ['Ds', 'E'] },
  { name: 'Dodo D', roles: ['Dd', 'E'] },
  { name: 'Gila', roles: ['Dc'] },
  { name: 'Romagnoli A', roles: ['Dc'] },
  { name: 'Marusic', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Gallo', roles: ['Ds', 'E'] },
  { name: 'Tomori', roles: ['Dc'] },
   { name: 'Terracciano F', roles: ['B', 'Dd', 'Ds'] },
  { name: 'Di Lorenzo', roles: ['Dd', 'E'] },
  { name: 'Angori', roles: ['Ds', 'E'] },
  { name: 'Rensch', roles: ['B', 'Dd', 'E'] },
  { name: 'Maripan', roles: ['Dc'] },
  { name: 'Kristensen T', roles: ['Dd', 'Dc'] },
  { name: 'Athekame', roles: ['Dd', 'E'] },
  { name: 'Belghali', roles: ['Dd', 'E'] },
  { name: 'Obrador', roles: ['Ds', 'E'] },
  { name: 'Zortea', roles: ['Dd', 'E'] },
  { name: 'De Winter', roles: ['Dd', 'Dc'] },
  { name: 'Norton-Cuffy', roles: ['Dd', 'E'] },
  { name: 'Buongiorno', roles: ['Dc'] },
  { name: 'Rrahmani', roles: ['Dc'] },
  { name: 'Circati', roles: ['Dc'] },
  { name: 'Muharemovic', roles: ['Dc'] },
  { name: 'Ghilardi', roles: ['Dc'] },
  { name: 'Idzes', roles: ['Dc'] },
  { name: 'Diego Carlos', roles: ['Dc'] },
  { name: 'Djimsiti', roles: ['Dc'] },
  { name: 'Kolasinac', roles: ['Ds', 'Dc'] },
  { name: 'Lucumi', roles: ['Dc'] },
  { name: 'Mina', roles: ['Dc'] },
  { name: 'Obert', roles: ['B', 'Ds', 'E'] },
  { name: 'Idrissi', roles: ['Ds', 'E'] },
  { name: 'Parisi F', roles: ['Ds', 'E'] },
  { name: 'Marcandalli', roles: ['Dc'] },
  { name: 'Cabal', roles: ['B', 'Ds', 'E'] },
  { name: 'Joao Mario N', roles: ['Dd', 'E'] },
  { name: 'Nuno Tavares', roles: ['Ds', 'E'] },
  { name: 'Gabbia', roles: ['Dc'] },
  { name: 'Zanoli', roles: ['Dd', 'E'] },
  { name: 'Caracciolo A', roles: ['Dc'] },
  { name: 'Angelino', roles: ['E'] },
  { name: 'Pedersen', roles: ['Dd', 'E'] },
  { name: 'Ulisses Garcia', roles: ['B', 'Ds', 'E'] },
  { name: 'Kossounou', roles: ['Dd', 'Dc'] },
  { name: 'Bellanova', roles: ['Dd', 'E'] },
  { name: 'Zappa', roles: ['B', 'Dd', 'E'] },
  { name: 'Barbieri', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Ranieri', roles: ['Ds', 'Dc'] },
  { name: 'Gatti', roles: ['Dc'] },
  { name: 'Provstgaard', roles: ['Dc'] },
  { name: 'Valenti', roles: ['Dc'] },
  { name: 'Canestrelli', roles: ['Dc'] },
  { name: 'Ismajli', roles: ['Dc'] },
  { name: 'Frese', roles: ['Ds', 'E'] },
  { name: 'Cuadrado', roles: ['E'] },
  { name: 'Britschgi', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Hien', roles: ['Dc'] },
  { name: 'Vitik', roles: ['Dc'] },
  { name: 'Smolcic', roles: ['Dd', 'E'] },
  { name: 'Folino', roles: ['Dc'] },
  { name: 'Pezzella', roles: ['Ds', 'E'] },
  { name: 'Comuzzo', roles: ['Dc'] },
  { name: 'Pongracic', roles: ['Dc'] },
  { name: 'Acerbi', roles: ['Dc'] },
  { name: 'Danilo Veiga', roles: ['Dd', 'E'] },
  { name: 'Walukiewicz', roles: ['Dd', 'Dc'] },
  { name: 'Doig', roles: ['Ds', 'E'] },
  { name: 'Bertola', roles: ['Dd', 'Ds', 'Dc'] },
  { name: 'Ehizibue', roles: ['Dd', 'E'] },
  { name: 'Kamara', roles: ['Ds', 'E'] },
  { name: 'Oyegoke', roles: ['B', 'Dd', 'E'] },
  { name: 'Bradaric D', roles: ['Ds', 'E'] },
  { name: 'Heggem', roles: ['Ds', 'Dc'] },
  { name: 'Troilo', roles: ['Dc'] },
  { name: 'Siebert', roles: ['Dc'] },
  { name: 'Ze Pedro', roles: ['Dd', 'Dc'] },
  { name: 'Ahanor', roles: ['B', 'Ds', 'E'] },
  { name: 'Van Der Brempt', roles: ['Dd', 'E'] },
  { name: 'Bianchetti', roles: ['Dc'] },
  { name: 'Floriani M', roles: ['Dd', 'E'] },
  { name: 'De Vrij', roles: ['Dc'] },
  { name: 'Patric', roles: ['Dd', 'Dc'] },
  { name: 'Lazzari M', roles: ['Dd', 'E'] },
  { name: 'Juan Jesus', roles: ['Ds', 'Dc'] },
  { name: 'Mathias Olivera', roles: ['B', 'Ds', 'E'] },
  { name: 'Calabresi', roles: ['B', 'Dd', 'E'] },
  { name: 'Lazaro', roles: ['Dd', 'E'] },
  { name: 'Ebosse', roles: ['Ds', 'Dc'] },
  { name: 'Nelsson', roles: ['Dc'] },
  { name: 'Tsimikas', roles: ['Ds', 'E'] },
  { name: 'Edmundsson', roles: ['Dc'] },
  { name: 'Fortini', roles: ['E'] },
  { name: 'Sabelli', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Darmian', roles: ['B', 'Dd', 'E'] },
  { name: 'Pellegrini Lu', roles: ['Ds', 'E'] },
  { name: 'Gaspar K', roles: ['Dc'] },
  { name: 'Estupinan', roles: ['Ds', 'E'] },
  { name: 'Marianucci', roles: ['Dc'] },
  { name: 'Mazzocchi', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Zemura', roles: ['Ds', 'E'] },
  { name: 'Valentini N', roles: ['Dc'] },
  { name: 'Bella-Kotchap', roles: ['Dc'] },
  { name: 'Coulibaly W', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Arizala', roles: ['Ds', 'E'] },
  { name: 'Lirola', roles: ['B', 'Dd', 'E'] },
  { name: 'Casale', roles: ['Dc'] },
  { name: 'De Silvestri', roles: ['Dd', 'E'] },
  { name: 'Lykogiannis', roles: ['Ds', 'E'] },
  { name: 'Dossena A', roles: ['Dc'] },
  { name: 'Ceccherini', roles: ['Dd', 'Dc'] },
  { name: 'Rugani', roles: ['Dc'] },
  { name: 'Romagna', roles: ['Dc'] },
  { name: 'Biraghi', roles: ['B', 'Ds', 'E'] },
  { name: 'Slotsager', roles: ['Dc'] },
  { name: 'Ndiaye A', roles: ['Dc'] },
  { name: 'Cham', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Ziolkowski', roles: ['Dc'] },
  { name: 'Rodriguez Ju', roles: ['Ds', 'Dc'] },
  { name: 'Albiol', roles: ['Dc'] },
  { name: 'Zatterstrom', roles: ['Dc'] },
  { name: 'Mlacic', roles: ['Dc'] },
  { name: 'Goldaniga', roles: ['Dc'] },
  { name: 'Otoa', roles: ['Dc'] },
  { name: 'Gigot', roles: ['Dc'] },
  { name: 'Hysaj', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Jean', roles: ['Dc'] },
  { name: 'Perez M', roles: ['Dd', 'Dc'] },
  { name: 'Ndaba', roles: ['Ds', 'E'] },
  { name: 'Coppola Fr', roles: ['Dc'] },
  { name: 'Pieragnolo', roles: ['Ds', 'E'] },
  { name: 'Denoon', roles: ['Dc'] },
  { name: 'Cande', roles: ['Ds', 'Dc'] },
  { name: 'Kouadio', roles: ['Dd', 'Dc'] },
  { name: 'Lamptey', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Nkounkou', roles: ['Ds', 'E'] },
  { name: 'Faye', roles: ['Dc'] },
  { name: 'Odogu', roles: ['Dc'] },
  { name: 'Bozhinov', roles: ['Dc'] },
  { name: 'Helland', roles: ['Dd', 'Dc'] },
  { name: 'Carboni F', roles: ['Ds', 'E'] },
  { name: 'Raterink', roles: ['Dd', 'E'] },
  { name: 'Pedro Felipe', roles: ['Dc'] },
  { name: 'Balbo', roles: ['Ds', 'E'] },
  { name: 'Nico Paz', roles: ['T', 'A'] },
  { name: 'Calhanoglu', roles: ['M', 'C'] },
  { name: 'Pulisic', roles: ['T', 'A'] },
  { name: 'McTominay', roles: ['C', 'T'] },
  { name: 'Rabiot', roles: ['C', 'T'] },
  { name: 'Baturina', roles: ['T'] },
  { name: 'Zielinski', roles: ['C'] },
  { name: 'Modric', roles: ['M', 'C'] },
  { name: 'Zaniolo', roles: ['T', 'A'] },
   { name: 'McKennie', roles: ['C', 'T'] },
  { name: 'Orsolini', roles: ['W', 'A'] },
  { name: 'Messias', roles: ['W', 'T'] },
  { name: 'Barella', roles: ['C'] },
  { name: 'Conceicao', roles: ['W', 'A'] },
  { name: 'De Bruyne', roles: ['T'] },
  { name: 'Kone I', roles: ['C'] },
  { name: 'Atta', roles: ['C', 'T'] },
  { name: 'Perrone', roles: ['M', 'C'] },
  { name: 'Da Cunha', roles: ['C', 'T'] },
  { name: 'Mandragora', roles: ['C'] },
  { name: 'Anguissa', roles: ['C'] },
  { name: 'Vlasic', roles: ['T'] },
  { name: 'Malinovskyi', roles: ['C', 'T'] },
  { name: 'Bernabe\'', roles: ['C'] },
  { name: 'Taylor', roles: ['C', 'T'] },
  { name: 'Zalewski', roles: ['W'] },
  { name: 'Isaksen', roles: ['W', 'A'] },
  { name: 'Saelemaekers', roles: ['E', 'W'] },
  { name: 'Pellegrini', roles: ['C', 'T'] },
  { name: 'Ekkelenkamp', roles: ['C', 'T'] },
  { name: 'Odgaard', roles: ['T'] },
  { name: 'Gudmundsson', roles: ['T', 'A'] },
  { name: 'Mkhitaryan', roles: ['C'] },
  { name: 'Locatelli M', roles: ['M', 'C'] },
  { name: 'Thuram K', roles: ['C'] },
  { name: 'Coulibaly L', roles: ['M', 'C'] },
  { name: 'Ederson J', roles: ['M', 'C'] },
  { name: 'Pasalic', roles: ['C', 'T'] },
  { name: 'Caqueret', roles: ['C', 'T'] },
  { name: 'Strefezza', roles: ['W', 'A'] },
  { name: 'Vandeputte', roles: ['W', 'T'] },
  { name: 'Thorsby', roles: ['C', 'T'] },
  { name: 'Cataldi', roles: ['M', 'C'] },
  { name: 'Zaccagni', roles: ['W', 'A'] },
  { name: 'Politano', roles: ['W'] },
  { name: 'Cristante', roles: ['M', 'C'] },
  { name: 'Manu Kone', roles: ['M', 'C'] },
  { name: 'Thorstvedt', roles: ['C', 'T'] },
  { name: 'Mazzitelli', roles: ['M', 'C'] },
  { name: 'Rowe', roles: ['W', 'T'] },
  { name: 'Gaetano', roles: ['M', 'C'] },
  { name: 'Ricci S', roles: ['M', 'C'] },
  { name: 'Loftus-Cheek', roles: ['C', 'T'] },
  { name: 'Neres', roles: ['W', 'A'] },
  { name: 'Pisilli', roles: ['C'] },
  { name: 'Volpato C', roles: ['W', 'T'] },
  { name: 'Casadei', roles: ['C', 'T'] },
  { name: 'Harrison', roles: ['W'] },
  { name: 'Brescianini', roles: ['C', 'T'] },
  { name: 'Bernardeschi', roles: ['W', 'T'] },
  { name: 'Fagioli', roles: ['M', 'C'] },
  { name: 'Fofana Y', roles: ['M', 'C'] },
  { name: 'Frendrup', roles: ['M', 'C'] },
  { name: 'Sucic', roles: ['C'] },
  { name: 'Kostic', roles: ['E', 'W'] },
  { name: 'Miretti', roles: ['C', 'T'] },
  { name: 'Basic', roles: ['M', 'C'] },
  { name: 'Mandela Keita', roles: ['M', 'C'] },
  { name: 'Baldanzi', roles: ['T'] },
  { name: 'Karlstrom', roles: ['M', 'C'] },
  { name: 'Sottil', roles: ['W', 'A'] },
  { name: 'Vergara', roles: ['W', 'T'] },
  { name: 'Alisson Santos', roles: ['W', 'A'] },
  { name: 'De Roon', roles: ['M', 'C'] },
  { name: 'Samardzic', roles: ['C', 'T'] },
  { name: 'Moro N', roles: ['M', 'C'] },
  { name: 'Ellertsson', roles: ['E', 'C'] },
  { name: 'Luis Henrique', roles: ['E', 'W'] },
  { name: 'Berisha M', roles: ['C', 'T'] },
  { name: 'Lobotka', roles: ['M', 'C'] },
  { name: 'Leris', roles: ['W'] },
  { name: 'Fadera', roles: ['W'] },
  { name: 'Matic', roles: ['M', 'C'] },
  { name: 'Zhegrova', roles: ['W'] },
  { name: 'Gandelman', roles: ['C', 'T'] },
  { name: 'Maldini D', roles: ['T', 'A'] },
  { name: 'Freuler', roles: ['M', 'C'] },
  { name: 'Folorunsho', roles: ['C', 'T'] },
  { name: 'Felici', roles: ['W'] },
  { name: 'Ndour', roles: ['C'] },
  { name: 'Ramadani', roles: ['M', 'C'] },
  { name: 'Bernede', roles: ['C'] },
  { name: 'Serdar', roles: ['C'] },
  { name: 'Piotrowski', roles: ['M', 'C'] },
  { name: 'Pobega', roles: ['M', 'C'] },
  { name: 'Aebischer', roles: ['C'] },
  { name: 'Fabbian', roles: ['C', 'T'] },
  { name: 'Adopo', roles: ['M', 'C'] },
  { name: 'Prati', roles: ['M', 'C'] },
  { name: 'Tramoni', roles: ['W', 'T'] },
  { name: 'El Shaarawy', roles: ['W'] },
  { name: 'Gineitis', roles: ['M', 'C'] },
  { name: 'Elmas', roles: ['W', 'T'] },
  { name: 'Gagliardini', roles: ['M', 'C'] },
  { name: 'Loyola', roles: ['M', 'C'] },
  { name: 'Sulemana', roles: ['M', 'C'] },
  { name: 'Masini', roles: ['M', 'C'] },
  { name: 'Pierotti', roles: ['W'] },
  { name: 'Bondo', roles: ['M', 'C'] },
  { name: 'Zerbin', roles: ['W'] },
  { name: 'Gilmour', roles: ['M', 'C'] },
  { name: 'Toure Id', roles: ['E', 'M'] },
  { name: 'Payero', roles: ['C'] },
  { name: 'Miller', roles: ['M', 'C'] },
  { name: 'Sorensen O', roles: ['C'] },
  { name: 'Oristanio', roles: ['W', 'T'] },
  { name: 'Caviglia', roles: ['M', 'C'] },
  { name: 'Zaragoza', roles: ['W', 'A'] },
  { name: 'Grassi', roles: ['M', 'C'] },
  { name: 'Musah', roles: ['C', 'W'] },
  { name: 'Estevez', roles: ['M', 'C'] },
  { name: 'Sohm', roles: ['C'] },
  { name: 'Akinsanmiro', roles: ['C'] },
  { name: 'Lipani', roles: ['M', 'C'] },
  { name: 'Harroui', roles: ['W', 'T'] },
  { name: 'Ilkhan', roles: ['M', 'C'] },
  { name: 'Amorim', roles: ['M', 'C'] },
  { name: 'Ferguson', roles: ['M', 'C'] },
  { name: 'Deiola', roles: ['M', 'C'] },
  { name: 'Sergi Roberto', roles: ['M', 'C'] },
  { name: 'Frattesi', roles: ['C', 'T'] },
  { name: 'Koopmeiners', roles: ['C', 'T'] },
  { name: 'Dele Bashiru', roles: ['C', 'T'] },
  { name: 'Maleh', roles: ['M', 'C'] },
  { name: 'Ordonez', roles: ['M', 'C'] },
  { name: 'Ondrejka', roles: ['W', 'A'] },
  { name: 'Piccinini G', roles: ['E', 'M'] },
  { name: 'El Aynaoui', roles: ['M', 'C'] },
  { name: 'Iannoni', roles: ['M', 'C'] },
   { name: 'Jashari', roles: ['M', 'C'] },
  { name: 'Lorran', roles: ['T'] },
  { name: 'Akpa-Akpro', roles: ['M', 'C'] },
  { name: 'Ngom', roles: ['M', 'C'] },
  { name: 'Iling-Junior', roles: ['E', 'W'] },
  { name: 'Fazzini', roles: ['C', 'T'] },
  { name: 'Rovella', roles: ['M', 'C'] },
  { name: 'Hojholt', roles: ['M', 'C'] },
  { name: 'Marin M', roles: ['M', 'C'] },
  { name: 'Anjorin', roles: ['C', 'T'] },
  { name: 'Zarraga', roles: ['M', 'C'] },
  { name: 'Niasse', roles: ['M', 'C'] },
  { name: 'Diouf A', roles: ['E', 'C'] },
  { name: 'Al-Musrati', roles: ['M', 'C'] },
  { name: 'Collocolo', roles: ['M', 'C'] },
  { name: 'Sabiri', roles: ['T'] },
  { name: 'Venturino', roles: ['W'] },
  { name: 'Belahyane', roles: ['M', 'C'] },
  { name: 'Helgason', roles: ['C', 'T'] },
  { name: 'Vural', roles: ['C'] },
  { name: 'Boloca', roles: ['M', 'C'] },
  { name: 'Tameze', roles: ['M', 'C'] },
   { name: 'Ilic', roles: ['M', 'C'] },
  { name: 'Suslov', roles: ['W', 'T'] },
  { name: 'Vranckx', roles: ['M', 'C'] },
  { name: 'Gorter', roles: ['M', 'C'] },
  { name: 'Onana J', roles: ['M', 'C'] },
  { name: 'Cornet', roles: ['W'] },
  { name: 'Bakola', roles: ['C', 'T'] },
  { name: 'Liteta', roles: ['M', 'C'] },
  { name: 'Marchwinski', roles: ['T'] },
  { name: 'Lovric', roles: ['C'] },
  { name: 'Adzic', roles: ['C', 'T'] },
  { name: 'Alex Sala', roles: ['C'] },
  { name: 'Stengs', roles: ['W', 'T'] },
  { name: 'Cremaschi', roles: ['E', 'C'] },
  { name: 'Fofana S', roles: ['M', 'C'] },
  { name: 'Przyborek', roles: ['W', 'T'] },
  { name: 'Lahdo', roles: ['C', 'T'] },
  { name: 'Martinez L', roles: ['Pc'] },
  { name: 'Thuram', roles: ['Pc'] },
  { name: 'Yildiz', roles: ['A'] },
  { name: 'Davis', roles: ['Pc'] },
  { name: 'Krstovic', roles: ['Pc'] },
  { name: 'Douvikas', roles: ['Pc'] },
  { name: 'Hojlund', roles: ['Pc'] },
  { name: 'Leao', roles: ['A'] },
  { name: 'Berardi', roles: ['A'] },
  { name: 'Esposito F', roles: ['Pc'] },
  { name: 'Scamacca', roles: ['Pc'] },
  { name: 'Simeone', roles: ['Pc'] },
  { name: 'Malen', roles: ['Pc'] },
  { name: 'Soule', roles: ['A'] },
  { name: 'Lauriente\'', roles: ['A'] },
  { name: 'Castro S', roles: ['Pc'] },
  { name: 'Bonazzoli', roles: ['A'] },
  { name: 'Bonny', roles: ['Pc'] },
  { name: 'Esposito S', roles: ['A'] },
  { name: 'Pellegrino Ma', roles: ['Pc'] },
  { name: 'Kean', roles: ['Pc'] },
  { name: 'Moreo', roles: ['A'] },
  { name: 'Nkunku', roles: ['A'] },
  { name: 'De Ketelaere', roles: ['A'] },
  { name: 'Pinamonti', roles: ['Pc'] },
  { name: 'Adams', roles: ['A'] },
  { name: 'Kilicsoy', roles: ['A'] },
  { name: 'Orban G', roles: ['Pc'] },
  { name: 'Colombo', roles: ['Pc'] },
  { name: 'Raspadori', roles: ['A'] },
  { name: 'Lukaku R', roles: ['Pc'] },
  { name: 'Vardy', roles: ['Pc'] },
  { name: 'Vitinha', roles: ['A'] },
  { name: 'Giovane S', roles: ['A'] },
  { name: 'Cambiaghi', roles: ['W', 'A'] },
  { name: 'Rodriguez J', roles: ['W', 'A'] },
  { name: 'Ekuban', roles: ['A'] },
  { name: 'David', roles: ['Pc'] },
  { name: 'Cancellieri', roles: ['W', 'A'] },
  { name: 'Dybala', roles: ['A'] },
  { name: 'Vlahovic', roles: ['Pc'] },
  { name: 'Pedro R', roles: ['A'] },
  { name: 'Banda', roles: ['W', 'A'] },
  { name: 'Gimenez S', roles: ['Pc'] },
  { name: 'Ferguson E', roles: ['Pc'] },
  { name: 'Durosinmi', roles: ['Pc'] },
  { name: 'Boga', roles: ['W', 'A'] },
  { name: 'Noslin', roles: ['A'] },
  { name: 'Fullkrug', roles: ['Pc'] },
  { name: 'Ratkov', roles: ['Pc'] },
  { name: 'Sulemana K', roles: ['A'] },
  { name: 'Borrelli', roles: ['Pc'] },
  { name: 'Ekhator', roles: ['A'] },
  { name: 'Dovbyk', roles: ['Pc'] },
  { name: 'Nzola', roles: ['Pc'] },
  { name: 'Vaz', roles: ['Pc'] },
  { name: 'Piccoli', roles: ['Pc'] },
  { name: 'Addai', roles: ['W', 'A'] },
  { name: 'Assane Diao', roles: ['W', 'A'] },
  { name: 'Solomon', roles: ['W', 'A'] },
  { name: 'Bowie', roles: ['Pc'] },
  { name: 'Okereke', roles: ['A'] },
  { name: 'N\'Dri', roles: ['W', 'A'] },
  { name: 'Zapata D', roles: ['Pc'] },
  { name: 'Buksa A', roles: ['Pc'] },
  { name: 'Stulic', roles: ['Pc'] },
  { name: 'Dallinga', roles: ['Pc'] },
  { name: 'Kuhn', roles: ['W', 'A'] },
  { name: 'Djuric', roles: ['Pc'] },
  { name: 'Mosquera', roles: ['Pc'] },
  { name: 'Cheddira', roles: ['Pc'] },
  { name: 'Dia', roles: ['A'] },
  { name: 'Meister', roles: ['Pc'] },
  { name: 'Sanabria', roles: ['Pc'] },
  { name: 'Openda', roles: ['Pc'] },
  { name: 'Belotti', roles: ['Pc'] },
  { name: 'Elphege', roles: ['Pc'] },
  { name: 'Kulenovic', roles: ['Pc'] },
  { name: 'Dominguez B', roles: ['W', 'A'] },
  { name: 'Pavoletti', roles: ['Pc'] },
  { name: 'Njie', roles: ['W', 'A'] },
  { name: 'Stojilkovic', roles: ['Pc'] },
  { name: 'Amin Sarr', roles: ['A'] },
  { name: 'Morata', roles: ['Pc'] },
  { name: 'Gueye', roles: ['Pc'] },
  { name: 'Milik', roles: ['Pc'] },
  { name: 'Camarda', roles: ['Pc'] },
  { name: 'Aboukhlal', roles: ['W', 'A'] },
  { name: 'Moumbagna', roles: ['Pc'] },
  { name: 'Almqvist', roles: ['W', 'A'] },
  { name: 'Moro L', roles: ['Pc'] },
  { name: 'Bayo', roles: ['Pc'] },
  { name: 'Frigan', roles: ['A'] },
  { name: 'Balentien', roles: ['A'] },
  { name: 'Arena A', roles: ['Pc'] },
  { name: 'Isaac', roles: ['Pc'] },
  { name: 'Trepy', roles: ['Pc'] },
  { name: 'Albarracin', roles: ['A'] },
  { name: 'Vermesan', roles: ['Pc'] },
  { name: 'Mendy P', roles: ['Pc'] },
  { name: 'Daffara', roles: ['Por'] },
  { name: 'Desplanches', roles: ['Por'] },
  { name: 'Grandi', roles: ['Por'] },
  { name: 'Happonen', roles: ['Por'] },
  { name: 'Lolic', roles: ['Por'] },
  { name: 'Mandas', roles: ['Por'] },
  { name: 'Mascardi', roles: ['Por'] },
  { name: 'Palmisani', roles: ['Por'] },
  { name: 'Piana', roles: ['Por'] },
  { name: 'Pizzignacco', roles: ['Por'] },
  { name: 'Stankovic F', roles: ['Por'] },
  { name: 'Stolz', roles: ['Por'] },
  { name: 'Strajnar', roles: ['Por'] },
  { name: 'Abankwah', roles: ['Dd', 'Dc'] },
  { name: 'Akpoguma', roles: ['Dc'] },
  { name: 'Alhassane', roles: ['Ds', 'E'] },
  { name: 'Amey', roles: ['Dc'] },
  { name: 'Antov', roles: ['Dc'] },
  { name: 'Bakoune', roles: ['Dd', 'E'] },
  { name: 'Birindelli', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Bjarkason', roles: ['E', 'W'] },
  { name: 'Bracaglia', roles: ['Ds', 'Dc'] },
  { name: 'Cacciamani', roles: ['E', 'W'] },
  { name: 'Calvani', roles: ['Dc'] },
  { name: 'Carboni A', roles: ['Ds', 'Dc'] },
  { name: 'Cittadini', roles: ['Dc'] },
  { name: 'Ciurria', roles: ['E', 'W'] },
  { name: 'Comert', roles: ['Dc'] },
  { name: 'Corrado', roles: ['Ds', 'E'] },
  { name: 'Correia T', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Cuenca A', roles: ['Ds', 'Dc'] },
  { name: 'Delli Carri', roles: ['Dc'] },
  { name: 'Diawara S', roles: ['Ds', 'Dc'] },
  { name: 'Doekhi', roles: ['Dc'] },
  { name: 'Dragusin', roles: ['Dc'] },
  { name: 'Franjic', roles: ['B', 'Ds', 'E'] },
  { name: 'Gelli J', roles: ['Dc'] },
  { name: 'Gelli', roles: ['C', 'T'] },
  { name: 'Hainaut', roles: ['Dd', 'E'] },
  { name: 'Halhal', roles: ['Dc'] },
  { name: 'Haps', roles: ['Ds', 'E'] },
  { name: 'Jimenez A', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Kaiki', roles: ['Ds', 'E'] },
  { name: 'Kofler', roles: ['Dc'] },
  { name: 'Koulierakis', roles: ['Dc'] },
  { name: 'Lucchesi', roles: ['Dc'] },
  { name: 'Mangas', roles: ['Ds', 'E'] },
  { name: 'Matturro', roles: ['Ds', 'Dc'] },
  { name: 'Missori', roles: ['Dd', 'E'] },
  { name: 'Mitaj', roles: ['Ds', 'E'] },
  { name: 'Monterisi', roles: ['Dc'] },
  { name: 'Moreno M', roles: ['Dc'] },
  { name: 'Oyono J', roles: ['Dd', 'E'] },
  { name: 'Oyono', roles: ['Dd', 'E'] },
  { name: 'Dembele A', roles: ['Dd', 'E'] },
  { name: 'El Bilal Toure', roles: ['Pc'] },
  { name: 'Ale Gomes', roles: ['Ds', 'Dc'] },
  { name: 'Altare', roles: ['Dc'] },
  { name: 'Rui Modesto', roles: ['E'] },
  { name: 'Wieteska', roles: ['Dc'] },
  { name: 'Veroli', roles: ['Ds', 'Dc'] },
  { name: 'Paz Y', roles: ['Dd', 'E'] },
  { name: 'Palma M', roles: ['Dc'] },
  { name: 'Odenthal', roles: ['Dc'] },
  { name: 'Martins K', roles: ['E', 'W'] },
  { name: 'Kouassi', roles: ['Dd', 'Dc'] },
  { name: 'Ilic M', roles: ['Dc'] },
  { name: 'Goglichidze', roles: ['Dd', 'Dc'] },
  { name: 'Posch', roles: ['Dd', 'Dc'] },
  { name: 'Rafa Marin', roles: ['Dc'] },
  { name: 'Salah Eddine', roles: ['Ds', 'E'] },
  { name: 'Balogh', roles: ['Dc'] },
  { name: 'Yan Couto', roles: ['Dd', 'E'] },
  { name: 'Sow', roles: ['M', 'C'] },
  { name: 'Pavard', roles: ['Dd', 'Dc'] },
  { name: 'Pedraza', roles: ['Ds', 'E'] },
  { name: 'Puczka', roles: ['Ds', 'E'] },
  { name: 'Sagrado', roles: ['Dd', 'E'] },
  { name: 'Schingtienne', roles: ['Dc'] },
  { name: 'Stones', roles: ['Dc'] },
  { name: 'Sverko', roles: ['Ds', 'Dc'] },
  { name: 'Valdepenas', roles: ['Ds', 'Dc'] },
  { name: 'Viery', roles: ['Ds', 'Dc'] },
  { name: 'Vogliacco', roles: ['Dd', 'Dc'] },
  { name: 'Alajbegovic', roles: ['W', 'T'] },
  { name: 'Amondarain', roles: ['M', 'C'] },
  { name: 'Busio', roles: ['M', 'C'] },
  { name: 'Calo\'', roles: ['M', 'C'] },
  { name: 'Camara A', roles: ['M', 'C'] },
  { name: 'Chakvetadze', roles: ['W', 'T'] },
  { name: 'Chukwueze', roles: ['E', 'W'] },
  { name: 'Cichella', roles: ['M', 'C'] },
  { name: 'Colombo L', roles: ['M', 'C'] },
  { name: 'Colpani', roles: ['T'] },
  { name: 'Dagasso', roles: ['C'] },
  { name: 'Diallo O', roles: ['W', 'A'] },
  { name: 'Douglas Luiz', roles: ['C'] },
  { name: 'Duncan', roles: ['C'] },
  { name: 'El Azzouzi A', roles: ['M', 'C'] },
  { name: 'Fini', roles: ['W'] },
  { name: 'Fitz-Jim', roles: ['M', 'C'] },
  { name: 'Ghedjemis', roles: ['W', 'A'] },
  { name: 'Hasa', roles: ['C', 'T'] },
  { name: 'Traore', roles: ['W', 'T'] },
  { name: 'Kaba', roles: ['M', 'C'] },
  { name: 'Kone B', roles: ['C'] },
  { name: 'Koutsoupias', roles: ['C'] },
  { name: 'Kvernadze', roles: ['W', 'A'] },
  { name: 'Liberali', roles: ['T'] },
  { name: 'Lisman', roles: ['W', 'A'] },
  { name: 'Meichtry', roles: ['W', 'T'] },
  { name: 'Milla', roles: ['M', 'C'] },
  { name: 'Oulai', roles: ['M', 'C'] },
  { name: 'Pessina', roles: ['M', 'C'] },
  { name: 'Romano', roles: ['M', 'C'] },
  { name: 'Stankovic A', roles: ['M', 'C'] },
  { name: 'Unai Gomez', roles: ['T'] },
  { name: 'Winks', roles: ['M', 'C'] },
  { name: 'Adams A', roles: ['Pc'] },
  { name: 'Adorante', roles: ['Pc'] },
  { name: 'Azon', roles: ['Pc'] },
  { name: 'Cutrone', roles: ['Pc'] },
  { name: 'Geubbels', roles: ['Pc'] },
  { name: 'Havel', roles: ['Pc'] },
  { name: 'Kolo Muani', roles: ['Pc'] },
  { name: 'Lauberbach', roles: ['Pc'] },
  { name: 'Lucca', roles: ['Pc'] },
  { name: 'Mota', roles: ['A'] },
  { name: 'Mutandwa', roles: ['Pc'] },
  { name: 'Petagna', roles: ['Pc'] },
  { name: 'Raimondo', roles: ['Pc'] },
  { name: 'Ramos G', roles: ['Pc'] },
  { name: 'Varela G', roles: ['Pc'] },
  { name: 'Yeboah J', roles: ['A'] },
  { name: 'Mastantuono', roles: ['W', 'T'] },
  { name: 'Robinson J', roles: ['A'] },
  { name: 'Rrahmani A', roles: ['Pc'] },
  { name: 'Chalobah', roles: ['Dd', 'Dc'] },
  { name: 'Molina N', roles: ['E'] },
  { name: 'Aurelio', roles: ['Ds', 'E'] },
  { name: 'Bakker', roles: ['E'] },
  { name: 'Grillitsch', roles: ['M', 'C'] },
  { name: 'Kevin Carlos', roles: ['Pc'] },
  { name: 'Romero D', roles: ['Pc'] },
  { name: 'Schmid', roles: ['W', 'T'] },
  { name: 'Spence', roles: ['E'] },
  { name: 'Terzic', roles: ['Ds', 'E'] },
  { name: 'Kike Perez', roles: ['C', 'T'] },
  { name: 'Cisse A', roles: ['W', 'T'] },
  { name: 'Forson', roles: ['W', 'T'] },
  { name: 'Lontani', roles: ['A'] },
  { name: 'Rodrigo Mora', roles: ['T'] },
  { name: 'Favasuli', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Diego Moreira', roles: ['W', 'E'] },
  { name: 'Cinquegrano', roles: ['Dd', 'E'] },
  { name: 'De Martis', roles: ['Pc'] },
  { name: 'Laerke', roles: ['W', 'A'] },
  { name: 'Leysen', roles: ['Ds', 'Dc'] },
  { name: 'Jones', roles: ['C'] },
  { name: 'Badiashile', roles: ['Dc'] },
  { name: 'Sutalo J', roles: ['Dc'] },
  { name: 'Birligea', roles: ['Pc'] },
  { name: 'Bobcek', roles: ['Pc'] },
  { name: 'Fatah', roles: ['W', 'A'] },
  { name: 'Foe Ondoa', roles: ['C'] },
  { name: 'Kambwala', roles: ['Dd', 'Dc'] },
  { name: 'Lulli', roles: ['E'] },
  { name: 'Macchioni', roles: ['Dc'] },
  { name: 'Maye', roles: ['Ds', 'Dc'] },
  { name: 'Mout', roles: ['C'] },
  { name: 'Ngonge', roles: ['A'] },
  { name: 'Osmajic', roles: ['Pc'] },
  { name: 'Tchato', roles: ['Dd', 'E'] },
  { name: 'Balerdi', roles: ['Dc'] },
  { name: 'Ciervo', roles: ['W'] },
  { name: 'Drobnic', roles: ['Dc'] },
  { name: 'Gonzalez N', roles: ['W', 'A'] },
  { name: 'Kessie', roles: ['C'] },
  { name: 'Theate', roles: ['Ds', 'Dc'] },
  { name: 'Noa Lang', roles: ['A'] },
  { name: 'Comotto C', roles: ['M', 'C'] },
  { name: 'El Azzouzi', roles: ['M', 'C'] },
  { name: 'Fayed', roles: ['Dc'] },
  { name: 'Beto', roles: ['Pc'] },
  { name: 'Caleta-Car', roles: ['Dc'] },
  { name: 'Gnonto', roles: ['W', 'A'] },
  { name: 'Hutchinson', roles: ['W', 'A'] },
  { name: 'Jovanovic', roles: ['W', 'T'] },
  { name: 'Massolin', roles: ['C', 'T'] },
  { name: 'Mbangula', roles: ['W', 'A'] },
  { name: 'Sarr P', roles: ['M', 'C'] },
  { name: 'Sugawara', roles: ['Dd', 'E'] },
  { name: 'Woltemade', roles: ['A'] },
  { name: 'Zeballos', roles: ['A'] },
  { name: 'Braganca', roles: ['C'] },
  { name: 'Drameh', roles: ['Dd', 'Ds', 'E'] },
  { name: 'Monteiro', roles: ['W', 'A'] },
  { name: 'Toni Fernandez', roles: ['T', 'A'] },
  { name: 'Patterson', roles: ['Dd', 'E'] },
  { name: 'Robinho J', roles: ['A'] },
  { name: 'Pedro Goncalves', roles: ['W', 'T'] },
  { name: 'Enem', roles: ['Pc'] },
  { name: 'Rodriguez R', roles: ['B', 'Ds', 'E'] },
  { name: 'Sierro', roles: ['M', 'C'] },
];

function normalizeText(value = '') {
  return String(value)
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’'".,]/g, '')
    .replace(/\s+/g, ' ');
}

function stripTrailingInitials(value = '') {
  const text = String(value || '').trim();

  return text
    .replace(/\s+(?:[a-z]\.?){1,4}$/i, '')   // M. / S. / F.P. / ecc.
    .replace(/\s+/g, ' ')
    .trim();
}

function normalizeMantraNameKey(value = '') {
  return normalizeText(value);
}

function buildNameVariants(value = '') {
  const raw = String(value || '').trim();
  const stripped = stripTrailingInitials(raw);

  const variants = new Set([
    normalizeMantraNameKey(raw),
    normalizeMantraNameKey(stripped),
    normalizeMantraNameKey(stripped).replace(/\s+/g, ''),
  ]);

  return [...variants].filter(Boolean);
}

const MANTRA_ROLE_CANONICAL_MAP = {
  POR: 'P',
  P: 'P',
  DD: 'Dd',
  DC: 'Dc',
  DS: 'Ds',
  B: 'B',
  E: 'E',
  M: 'M',
  C: 'C',
  W: 'W',
  T: 'T',
  A: 'A',
  PC: 'Pc',
  RM: 'RM',
};

function normalizeMantraRole(role = '') {
  const cleaned = String(role || '').trim().replace(/\s+/g, '');
  if (!cleaned) return null;

  const key = cleaned.toUpperCase();
  return MANTRA_ROLE_CANONICAL_MAP[key] || cleaned;
}

export function buildMantraRoleMap(rows = DEFAULT_MANTRA_ROLE_CONFIGURATION) {
  const map = {};

  (rows || []).forEach((row) => {
    const roles = Array.isArray(row?.roles)
      ? row.roles.map(normalizeMantraRole).filter(Boolean)
      : String(row?.roles || '')
          .split('/')
          .map((r) => normalizeMantraRole(r))
          .filter(Boolean);

    if (!roles.length) return;

    const keys = buildNameVariants(row?.name || '');
    keys.forEach((key) => {
      if (!key) return;
      if (!map[key]) map[key] = roles;
    });
  });

  return map;
}

export function getMantraRolesForPlayer(playerName, roleMap = buildMantraRoleMap()) {
  const keys = buildNameVariants(playerName || '');

  for (const key of keys) {
    if (roleMap[key]) return roleMap[key];
  }

  return [];
}

export function isValidMantraRoleValue(value) {
  return typeof value === 'string' && value.trim().length > 0;
}

export default DEFAULT_MANTRA_ROLE_CONFIGURATION;

// ─── CONFIGURAZIONE MODULI E RUOLI MANTRA ────────────────────────────────────
// Fonte ufficiale: https://www.fantacalcio.it/regolamenti/sistema-mantra
// Unico punto di verità per moduli e ruoli Mantra.
// Importato da AuctionFormationTab e AuctionMantraManageTab.

export const MANTRA_TOKEN_ORDER = ['P', 'Dd', 'Dc', 'Ds', 'B', 'E', 'M', 'C', 'W', 'T', 'A', 'Pc'];

export const MANTRA_ROW_ORDER = ['P', 'D', 'C', 'T', 'A'];

export const MANTRA_TOKEN_PATTERN = /(Pc|Dd|Dc|Ds|B|E|M|C|W|T|A|P)/gi;

export const MANTRA_PRESETS = {
  343: {
    label: '343',
    rows: [
      { key: 'P', title: 'Portiere',     subtitle: 'P',               slots: [['P']] },
      { key: 'D', title: 'Difesa',       subtitle: 'Dc · Dc · Dc/B',  slots: [['Dc'], ['Dc'], ['Dc', 'B']] },
      { key: 'C', title: 'Centrocampo',  subtitle: 'E · M/C · C · E', slots: [['E'], ['M', 'C'], ['C'], ['E']] },
      { key: 'A', title: 'Attacco',      subtitle: 'W/A · A/Pc · W/A',slots: [['W', 'A'], ['A', 'Pc'], ['W', 'A']] },
    ],
  },
  3412: {
    label: '3412',
    rows: [
      { key: 'P', title: 'Portiere',    subtitle: 'P',               slots: [['P']] },
      { key: 'D', title: 'Difesa',      subtitle: 'Dc · Dc · Dc/B',  slots: [['Dc'], ['Dc'], ['Dc', 'B']] },
      { key: 'C', title: 'Centrocampo', subtitle: 'E · M/C · C · E', slots: [['E'], ['M', 'C'], ['C'], ['E']] },
      { key: 'T', title: 'Trequarti',   subtitle: 'T',               slots: [['T']] },
      { key: 'A', title: 'Attacco',     subtitle: 'A/Pc · A/Pc',     slots: [['A', 'Pc'], ['A', 'Pc']] },
    ],
  },
  3421: {
    label: '3421',
    rows: [
      { key: 'P', title: 'Portiere',    subtitle: 'P',                  slots: [['P']] },
      { key: 'D', title: 'Difesa',      subtitle: 'Dc · Dc · Dc/B',     slots: [['Dc'], ['Dc'], ['Dc', 'B']] },
      { key: 'C', title: 'Centrocampo', subtitle: 'E/W · M · M/C · E',  slots: [['E', 'W'], ['M'], ['M', 'C'], ['E']] },
      { key: 'T', title: 'Trequarti',   subtitle: 'T · T/A',            slots: [['T'], ['T', 'A']] },
      { key: 'A', title: 'Attacco',     subtitle: 'A/Pc',               slots: [['A', 'Pc']] },
    ],
  },
  352: {
    label: '352',
    rows: [
      { key: 'P', title: 'Portiere',    subtitle: 'P',                       slots: [['P']] },
      { key: 'D', title: 'Difesa',      subtitle: 'Dc · Dc · Dc/B',          slots: [['Dc'], ['Dc'], ['Dc', 'B']] },
      { key: 'C', title: 'Centrocampo', subtitle: 'E/W · M/C · M · C · E',   slots: [['E', 'W'], ['M', 'C'], ['M'], ['C'], ['E']] },
      { key: 'A', title: 'Attacco',     subtitle: 'A/Pc · A/Pc',             slots: [['A', 'Pc'], ['A', 'Pc']] },
    ],
  },
  3511: {
    label: '3511',
    rows: [
      { key: 'P', title: 'Portiere',    subtitle: 'P',                       slots: [['P']] },
      { key: 'D', title: 'Difesa',      subtitle: 'Dc · Dc · Dc/B',          slots: [['Dc'], ['Dc'], ['Dc', 'B']] },
      { key: 'C', title: 'Centrocampo', subtitle: 'E/W · M · C · M · E/W',   slots: [['E', 'W'], ['M'], ['C'], ['M'], ['E', 'W']] },
      { key: 'T', title: 'Trequarti',   subtitle: 'T/A',                     slots: [['T', 'A']] },
      { key: 'A', title: 'Attacco',     subtitle: 'A/Pc',                    slots: [['A', 'Pc']] },
    ],
  },
  433: {
    label: '433',
    rows: [
      { key: 'P', title: 'Portiere',    subtitle: 'P',                  slots: [['P']] },
      { key: 'D', title: 'Difesa',      subtitle: 'Dd · Dc · Dc · Ds',  slots: [['Dd'], ['Dc'], ['Dc'], ['Ds']] },
      { key: 'C', title: 'Centrocampo', subtitle: 'M/C · M · C',        slots: [['M', 'C'], ['M'], ['C']] },
      { key: 'A', title: 'Attacco',     subtitle: 'W/A · A/Pc · W/A',   slots: [['W', 'A'], ['A', 'Pc'], ['W', 'A']] },
    ],
  },
  4312: {
    label: '4312',
    rows: [
      { key: 'P', title: 'Portiere',    subtitle: 'P',                    slots: [['P']] },
      { key: 'D', title: 'Difesa',      subtitle: 'Dd · Dc · Dc · Ds',    slots: [['Dd'], ['Dc'], ['Dc'], ['Ds']] },
      { key: 'C', title: 'Centrocampo', subtitle: 'M/C · M · C',          slots: [['M', 'C'], ['M'], ['C']] },
      { key: 'T', title: 'Trequarti',   subtitle: 'T',                    slots: [['T']] },
      { key: 'A', title: 'Attacco',     subtitle: 'T/A/Pc · A/Pc',        slots: [['T', 'A', 'Pc'], ['A', 'Pc']] },
    ],
  },
  442: {
    label: '442',
    rows: [
      { key: 'P', title: 'Portiere',    subtitle: 'P',                     slots: [['P']] },
      { key: 'D', title: 'Difesa',      subtitle: 'Dd · Dc · Dc · Ds',     slots: [['Dd'], ['Dc'], ['Dc'], ['Ds']] },
      { key: 'C', title: 'Centrocampo', subtitle: 'E/W · M/C · C · E',     slots: [['E', 'W'], ['M', 'C'], ['C'], ['E']] },
      { key: 'A', title: 'Attacco',     subtitle: 'A/Pc · A/Pc',           slots: [['A', 'Pc'], ['A', 'Pc']] },
    ],
  },
  4141: {
    label: '4141',
    rows: [
      { key: 'P', title: 'Portiere',   subtitle: 'P',                      slots: [['P']] },
      { key: 'D', title: 'Difesa',     subtitle: 'Dd · Dc · Dc · Ds',      slots: [['Dd'], ['Dc'], ['Dc'], ['Ds']] },
      { key: 'C', title: 'Mediano',    subtitle: 'M',                      slots: [['M']] },
      { key: 'T', title: 'Trequarti',  subtitle: 'E/W · C/T · T · W',      slots: [['E', 'W'], ['C', 'T'], ['T'], ['W']] },
      { key: 'A', title: 'Attacco',    subtitle: 'A/Pc',                   slots: [['A', 'Pc']] },
    ],
  },
  4411: {
    label: '4411',
    rows: [
      { key: 'P', title: 'Portiere',    subtitle: 'P',                     slots: [['P']] },
      { key: 'D', title: 'Difesa',      subtitle: 'Dd · Dc · Dc · Ds',     slots: [['Dd'], ['Dc'], ['Dc'], ['Ds']] },
      { key: 'C', title: 'Centrocampo', subtitle: 'E/W · M · C · E/W',     slots: [['E', 'W'], ['M'], ['C'], ['E', 'W']] },
      { key: 'T', title: 'Trequarti',   subtitle: 'T/A',                   slots: [['T', 'A']] },
      { key: 'A', title: 'Attacco',     subtitle: 'A/Pc',                  slots: [['A', 'Pc']] },
    ],
  },
  4231: {
    label: '4231',
    rows: [
      { key: 'P', title: 'Portiere',    subtitle: 'P',                     slots: [['P']] },
      { key: 'D', title: 'Difesa',      subtitle: 'Dd · Dc · Dc · Ds',     slots: [['Dd'], ['Dc'], ['Dc'], ['Ds']] },
      { key: 'C', title: 'Centrocampo', subtitle: 'M · M/C',               slots: [['M'], ['M', 'C']] },
      { key: 'T', title: 'Trequarti',   subtitle: 'W/T · T · W/A',         slots: [['W', 'T'], ['T'], ['W', 'A']] },
      { key: 'A', title: 'Attacco',     subtitle: 'A/Pc',                  slots: [['A', 'Pc']] },
    ],
  },
};

export const MANTRA_PRESET_KEYS = Object.keys(MANTRA_PRESETS);

export const MANTRA_ROLE_THEME = {
  // Portiere — giallo
  P:  { bg: 'rgba(245,197,66,.18)',  border: 'rgba(245,197,66,.36)',  color: '#f5c542' },
  // Difensori — sfumature di verde
  Dc: { bg: 'rgba(34,197,94,.20)',   border: 'rgba(34,197,94,.40)',   color: '#22c55e' },
  Dd: { bg: 'rgba(74,222,128,.18)',  border: 'rgba(74,222,128,.36)',  color: '#4ade80' },
  Ds: { bg: 'rgba(20,184,166,.18)',  border: 'rgba(20,184,166,.36)',  color: '#2dd4bf' },
  B:  { bg: 'rgba(16,185,129,.18)',  border: 'rgba(16,185,129,.36)',  color: '#10b981' },
  // Centrocampisti — sfumature di blu
  E:  { bg: 'rgba(99,102,241,.18)',  border: 'rgba(99,102,241,.36)',  color: '#818cf8' },
  M:  { bg: 'rgba(59,130,246,.20)',  border: 'rgba(59,130,246,.40)',  color: '#3b82f6' },
  C:  { bg: 'rgba(14,165,233,.18)',  border: 'rgba(14,165,233,.36)',  color: '#0ea5e9' },
  W:  { bg: 'rgba(56,189,248,.18)',  border: 'rgba(56,189,248,.36)',  color: '#38bdf8' },
  T:  { bg: 'rgba(96,165,250,.18)',  border: 'rgba(96,165,250,.36)',  color: '#60a5fa' },
  // Attaccanti — sfumature di rosso
  A:  { bg: 'rgba(239,68,68,.18)',   border: 'rgba(239,68,68,.36)',   color: '#ef4444' },
  // Pc — rosso scuro (centravanti puro)
  Pc: { bg: 'rgba(153,27,27,.22)',   border: 'rgba(153,27,27,.48)',   color: '#b91c1c' },
};

export const ROLE_COMPATIBILITY_MAP = {
  P:  [],
  Dc: ['Dd', 'Ds', 'B'],
  Dd: ['Dc', 'Ds', 'B', 'E'],
  Ds: ['Dc', 'Dd', 'B', 'E'],
  B:  ['Dc', 'Dd', 'Ds', 'E'],
  E:  ['M', 'C', 'W', 'T'],
  M:  ['E', 'C', 'W', 'T'],
  C:  ['M', 'W', 'T', 'A'],
  W:  ['M', 'C', 'T', 'A'],
  T:  ['W', 'C', 'A'],
  A:  ['T', 'W', 'Pc'],
  Pc: ['A', 'T'],
};

export const ROLE_FINANCE_BUCKET = {
  P:  'P',
  Dd: 'D', Dc: 'D', Ds: 'D', B: 'D',
  E:  'D',
  M:  'C',
  C:  'C', W: 'C', T: 'C',
  A:  'A', Pc: 'A',
};